import { useCallback } from "react";
import { OfflinePrefetchProps } from "../interface";
import { usePrefetch } from "app/services/api/locationsApi";
import { useDispatch } from "react-redux";
import { locationsApi } from "app/services/api/locationsApi";
import {
  usePrefetchUtils,
  executeSimplePrefetch,
} from "../utils/usePrefetchUtils";

export function usePrefetchLocations({ enabled }: OfflinePrefetchProps) {
  const prefetch = usePrefetch("getAllLocations");
  const dispatch = useDispatch();

  const handlePrefetch = useCallback(async () => {
    await executeSimplePrefetch({
      name: "Locations",
      fetchFn: () => {
        // Reset locations before prefetching
        // Locations are stored in IndexedDB and will not refresh
        // unless we reset the state
        dispatch(locationsApi.util.resetApiState());
        prefetch();
      },
    });
  }, [prefetch, dispatch]);

  usePrefetchUtils({
    enabled,
    prefetchHandler: handlePrefetch,
  });
}
